let config: { REACT_APP_API: string; REACT_APP_DNS: string; REACT_APP_ORDER_EDITOR_URL?: string } | null = null;

export async function loadConfig() {
  if (config) return config;
  const response = await fetch('/settings.json');
  config = await response.json();
  return config;
}

export async function getApiUrl(): Promise<string> {
  const config = await loadConfig();
  return config?.REACT_APP_API || '';
}

export async function getDnsUrl(): Promise<string> {
  const config = await loadConfig();
  return config?.REACT_APP_DNS || '';
}
